export default __webpack_public_path__ + "static/media/chigo-screenshot-01.b9e6c91f.png";